import { useContext } from "react";

import { WiseOwlContext } from "../../providers";
import { WiseOwlContextProps } from "../../providers/definitions/types";

const useWiseOwlContext = (): WiseOwlContextProps => {
  const wiseOwlContext = useContext(WiseOwlContext);
  return wiseOwlContext;
};

export default useWiseOwlContext;
